// import { pageTableInfoFragment } from '../graphql/fragment/page-table-info-fragment';
// import { sharingDocumentFragment } from '../graphql/fragment/sharing-document-fragment';
// import { sharingDocumentTableFragment } from '../graphql/fragment/sharing-document-table-fragment';
// import { sharingDocumentTableConnectionFragment } from '../graphql/fragment/sharing-document-table-connection-fragment';

export const storeContractorFragments = {
    // pageTableInfoFragment,
    // sharingDocumentFragment,
    // sharingDocumentTableFragment,
    // sharingDocumentTableConnectionFragment,
};
